import { MotionValue, useTransform } from 'framer-motion';
import { ItemOffset } from './ecosystem-orbit';
import { PHASE_1_END, PHASE_2_END, PICTOGRAM_SCALE_START } from './ecosystem-phases';

function useItemMotion(scrollYProgress: MotionValue<number>, offset: ItemOffset) {
    const x = useTransform(scrollYProgress, [0, PHASE_1_END], [offset.x, 0]);
    const y = useTransform(scrollYProgress, [0, PHASE_1_END], [offset.y, 0]);
    const pictogramScale = useTransform(scrollYProgress, [0, PHASE_2_END * 0.8], [PICTOGRAM_SCALE_START, 1]);
    const descriptionOpacity = useTransform(scrollYProgress, [PHASE_1_END, PHASE_2_END * 0.8], [0, 1]);

    return { x, y, pictogramScale, descriptionOpacity, scrollYProgress };
}

const EMPTY_OFFSET: ItemOffset = { x: 0, y: 0 };

export function useEcosystemItemMotion(scrollYProgress: MotionValue<number>, offsets: ItemOffset[]) {
    const motion0 = useItemMotion(scrollYProgress, offsets[0] ?? EMPTY_OFFSET);
    const motion1 = useItemMotion(scrollYProgress, offsets[1] ?? EMPTY_OFFSET);
    const motion2 = useItemMotion(scrollYProgress, offsets[2] ?? EMPTY_OFFSET);

    return [motion0, motion1, motion2];
}
